(() => {
  const initialize = root => {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const filterForm = root.querySelector('.s2t-collection__filter-form');
    // Normal GET navigation keeps server rendering, pagination and browser Back native.
    filterForm?.addEventListener('submit', () => {
      filterForm.querySelectorAll('input[type="number"]').forEach(input => { if (input.value === '') input.disabled = true; });
    });
    const dialogs = root.querySelectorAll('dialog');
    if (typeof HTMLDialogElement !== 'undefined' && HTMLDialogElement.prototype.showModal) {
      root.classList.add('s2t-collection--enhanced');
      // Follow the actual visible header, including its hide-on-scroll setting.
      const toolbar = root.querySelector('.s2t-collection__toolbar');
      const header = document.querySelector('.t4s-section-header');
      let frame, lastOffset = -1;
      const updateOffset = () => {
        frame = null;
        const rect = header?.getBoundingClientRect();
        const offset = rect && rect.top <= 1 ? Math.max(0, Math.ceil(rect.bottom)) : 0;
        if (offset !== lastOffset) {
          root.style.setProperty('--s2t-collection-header-offset', `${offset}px`);
          lastOffset = offset;
        }
      };
      const scheduleOffset = () => { if (!frame) frame = requestAnimationFrame(updateOffset); };
      const sizeObserver = new ResizeObserver(() => {
        root.style.setProperty('--s2t-collection-toolbar-height', `${toolbar.offsetHeight}px`);
        scheduleOffset();
      });
      sizeObserver.observe(toolbar);
      if (header) sizeObserver.observe(header);
      window.addEventListener('scroll', scheduleOffset, {passive:true});
      window.addEventListener('resize', scheduleOffset, {passive:true});
      header?.addEventListener('transitionend', scheduleOffset);
      updateOffset();
      root.closest('.shopify-section')?.addEventListener('shopify:section:unload', () => {
        sizeObserver.disconnect();
        window.removeEventListener('scroll', scheduleOffset);
        window.removeEventListener('resize', scheduleOffset);
        header?.removeEventListener('transitionend', scheduleOffset);
        if (frame) cancelAnimationFrame(frame);
      }, {once:true});
      const nav = root.querySelector('[data-collection-nav]');
      const navHome = root.querySelector('[data-collection-nav-home]');
      root.querySelector('[data-collection-dialog="filters"]').append(filterForm);
      root.querySelectorAll('[data-collection-open],[data-collection-close]').forEach(button => button.hidden = false);
      let trigger, oldOverflow, savedScrollY;
      const close = dialog => dialog.close();
      root.querySelectorAll('[data-collection-open]').forEach(button => button.addEventListener('click', () => {
        const dialog = root.querySelector(`[data-collection-dialog="${button.dataset.collectionOpen}"]`);
        if (button.dataset.collectionOpen === 'nav') dialog.append(nav);
        trigger = button;
        savedScrollY = window.scrollY;
        oldOverflow = document.body.style.overflow;
        document.body.style.overflow = 'hidden';
        dialog.showModal();
        dialog.querySelector('[data-collection-close]').focus({preventScroll:true});
      }));
      dialogs.forEach(dialog => {
        dialog.addEventListener('click', event => { if (event.target === dialog && event.clientX < dialog.getBoundingClientRect().left) close(dialog); });
        dialog.addEventListener('close', () => {
          if (dialog.dataset.collectionDialog === 'nav') navHome.append(nav);
          document.body.style.overflow = oldOverflow ?? '';
          trigger?.focus({preventScroll:true});
          window.scrollTo({top:savedScrollY, behavior:"instant"});
          scheduleOffset();
        });
      });
      root.querySelectorAll('[data-collection-close]').forEach(button => button.addEventListener('click', () => button.closest('dialog')?.close()));
      const desktop = matchMedia('(min-width: 1024px)');
      desktop.addEventListener('change', event => { const dialog = root.querySelector('[data-collection-dialog="nav"]'); if (event.matches && dialog.open) close(dialog); });
    }
    const carousel = root.querySelector('[data-collection-carousel]');
    if (carousel) {
      const previous = root.querySelector('[data-collection-previous]');
      const next = root.querySelector('[data-collection-next]');
      const deferred = root.querySelector('[data-collection-deferred]');
      const pending = deferred?.content;
      const status = root.querySelector('[data-collection-carousel-status]');
      const hasMore = () => Boolean(pending?.childElementCount);
      root.querySelector('[data-collection-carousel-controls]').hidden = false;
      const update = () => {
        previous.disabled = carousel.scrollLeft <= 2;
        next.disabled = !hasMore() && carousel.scrollLeft + carousel.clientWidth >= carousel.scrollWidth - 2;
        if (status) {
          status.hidden = false;
          status.textContent = `${carousel.querySelectorAll('.s2t-collection__tile').length} of ${carousel.dataset.collectionTotal} collections`;
        }
      };
      const loadMore = () => {
        if (!hasMore()) return;
        const batch = document.createDocumentFragment();
        for (let i = 0; i < 10 && pending.firstElementChild; i++) batch.append(pending.firstElementChild);
        carousel.append(batch);
        update();
      };
      const move = direction => {
        if (direction > 0 && hasMore() && carousel.scrollLeft + carousel.clientWidth * 2 >= carousel.scrollWidth - 2) loadMore();
        carousel.scrollBy({left:direction * carousel.clientWidth * .8, behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
      };
      previous.addEventListener('click', () => move(-1));
      next.addEventListener('click', () => move(1));
      carousel.addEventListener('scroll', () => {
        if (carousel.scrollLeft > 0 && carousel.scrollLeft + carousel.clientWidth >= carousel.scrollWidth - 100) loadMore();
        update();
      }, {passive:true});
      carousel.addEventListener('keydown', event => {
        if (event.target !== carousel || !['ArrowLeft','ArrowRight'].includes(event.key)) return;
        event.preventDefault(); move(event.key === 'ArrowRight' ? 1 : -1);
      });
      const carouselObserver = new ResizeObserver(update);
      carouselObserver.observe(carousel);
      root.closest('.shopify-section')?.addEventListener('shopify:section:unload', () => carouselObserver.disconnect(), {once:true});
      update();
    }
    // Content editors may include legacy links in descriptions/FAQ rich text.
    root.querySelectorAll('.s2t-collection__richtext a,.s2t-collection__answer a').forEach(link => {
      const path = new URL(link.href, location.href).pathname;
      if (/^\/pages\/(?:dtf-pressing-instructions|what-are-uv-dtf-transfers|contact|privacy-policy|shipping|refund|placement)/.test(path) || path.startsWith('/policies/')) {
        link.target = '_blank'; link.rel = 'noopener';
        const notice = document.createElement('span'); notice.className = 's2t-sr-only'; notice.textContent = ' (opens in a new tab)'; link.append(notice);
      }
    });
  };
  document.querySelectorAll('[data-s2t-collection]').forEach(initialize);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-s2t-collection]').forEach(initialize));
})();
